var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c(
            "form",
            {
              staticClass: "quotetool__step",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("h2", { staticClass: "quotetool__step-heading" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.labels.stepOneTitle) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "quotetool__step-form-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.businessName.$error,
                      },
                    },
                    [
                      _c("label", { attrs: { for: "businessName" } }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneBusinessNameLabel) + " *"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.businessName.$model,
                            expression: "$v.businessName.$model",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "businessName",
                          placeholder:
                            _vm.labels.stepOneBusinessNamePlaceholder,
                        },
                        domProps: { value: _vm.$v.businessName.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.businessName,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.businessName.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneBusinessNameValidationMsg)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error":
                          _vm.$v.title.$error ||
                          _vm.$v.firstName.$error ||
                          _vm.$v.lastName.$error,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.labels.stepOneFullNameLabel) + "*"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                          _c("div", { staticClass: "custom-select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.title.$model,
                                    expression: "$v.title.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.$v.title,
                                      "$model",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "mr" } }, [
                                  _vm._v("Mr"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "mrs" } }, [
                                  _vm._v("Mrs"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "ms" } }, [
                                  _vm._v("Ms"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.firstName.$model,
                                expression: "$v.firstName.$model",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder:
                                _vm.labels.stepOneFirstNamePlaceholder,
                            },
                            domProps: { value: _vm.$v.firstName.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.firstName,
                                  "$model",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.lastName.$model,
                                expression: "$v.lastName.$model",
                                modifiers: { trim: true },
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder:
                                _vm.labels.stepOneLastNamePlaceholder,
                            },
                            domProps: { value: _vm.$v.lastName.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.lastName,
                                  "$model",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.title.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.labels.stepOneFullNameValidationMsg)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.firstName.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.labels.stepOneFullNameValidationMsg)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.lastName.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.labels.stepOneFullNameValidationMsg)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.email.$error },
                    },
                    [
                      _c("label", { attrs: { for: "email" } }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneEmailAddressLabel) + "*"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.email.$model,
                            expression: "$v.email.$model",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "email",
                          id: "email",
                          placeholder:
                            _vm.labels.stepOneEmailAddressPlaceholder,
                        },
                        domProps: { value: _vm.$v.email.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.email,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.email.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("E-mail is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.email.email
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("E-mail format is invalid"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.mainPhoneNumber.$error,
                      },
                    },
                    [
                      _c("label", { attrs: { for: "mainPhoneNum" } }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneMainPhoneNumberLabel) + "*"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.mainPhoneNumber.$model,
                            expression: "$v.mainPhoneNumber.$model",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "mainPhoneNum" },
                        domProps: { value: _vm.$v.mainPhoneNumber.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.mainPhoneNumber,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.mainPhoneNumber.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneMainPhoneNumberValidationMsg)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.mainPhoneNumber.numeric
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(_vm.labels.stepOneMainPhoneNumberValidationMsg)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "alternativePhoneNum" } }, [
                      _vm._v(
                        _vm._s(_vm.labels.stepOneAlternativePhoneNumberLabel)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.altPhoneNumber,
                          expression: "altPhoneNumber",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "alternativePhoneNum" },
                      domProps: { value: _vm.altPhoneNumber },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.altPhoneNumber = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "checkbox",
                      class: {
                        "form-group--error":
                          _vm.$v.decisionAuthorisation.$error,
                      },
                    },
                    [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.decisionAuthorisation.$model,
                              expression: "$v.decisionAuthorisation.$model",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: true,
                            checked: Array.isArray(
                              _vm.$v.decisionAuthorisation.$model
                            )
                              ? _vm._i(
                                  _vm.$v.decisionAuthorisation.$model,
                                  true
                                ) > -1
                              : _vm.$v.decisionAuthorisation.$model,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.$v.decisionAuthorisation.$model,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = true,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.$v.decisionAuthorisation,
                                      "$model",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.$v.decisionAuthorisation,
                                      "$model",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.$v.decisionAuthorisation,
                                  "$model",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.labels.stepOneAuthorisationConfirmationLabel
                            ) +
                            "*\n                        "
                        ),
                        _c("span", { staticClass: "checkmark" }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.decisionAuthorisation.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("This field is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.decisionAuthorisation.isTrue
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("This field is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group radio-group",
                      class: { "form-group--error": _vm.$v.quoteType.$error },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.labels.stepOneQuoteTypeLabel) + "*"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.quoteType.$model,
                                expression: "$v.quoteType.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "quoteType",
                              id: "quoteTypeNew",
                              value: "new",
                            },
                            domProps: {
                              checked: _vm._q(_vm.$v.quoteType.$model, "new"),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.quoteType,
                                  "$model",
                                  "new"
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.labels.stepOneNewQuoteRadioLabel) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.quoteType.$model,
                                expression: "$v.quoteType.$model",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "quoteType",
                              id: "quoteTypeExisting",
                              value: "existing",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.$v.quoteType.$model,
                                "existing"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.quoteType,
                                  "$model",
                                  "existing"
                                )
                              },
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.labels.stepOneExistingCustomerRadioLabel
                              ) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.quoteType.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("This field is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: {
                        "form-group--error": _vm.$v.hasAcceptedPolicy.$error,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.labels.stepOneSaveDetailsLabel) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.hasAcceptedPolicy.$model,
                                expression: "$v.hasAcceptedPolicy.$model",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: true,
                              checked: Array.isArray(
                                _vm.$v.hasAcceptedPolicy.$model
                              )
                                ? _vm._i(
                                    _vm.$v.hasAcceptedPolicy.$model,
                                    true
                                  ) > -1
                                : _vm.$v.hasAcceptedPolicy.$model,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.$v.hasAcceptedPolicy.$model,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = true,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.$v.hasAcceptedPolicy,
                                        "$model",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.$v.hasAcceptedPolicy,
                                        "$model",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.$v.hasAcceptedPolicy,
                                    "$model",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.labels.stepOneSaveDetailsCheckboxLabel
                              ) +
                              "*\n                            "
                          ),
                          _c("span", { staticClass: "checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.$v.hasAcceptedPolicy.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.labels.stepOneSaveDetailsCheckboxValidationMsg
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.hasAcceptedPolicy.isTrue
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.labels.stepOneSaveDetailsCheckboxValidationMsg
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn--chevron",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.labels.stepOneSubmitButtonLabel))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "section--light-blue" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "container container--max-width-1010 text-center",
                  },
                  [
                    _c("h2", { staticClass: "quotetool__step-heading" }, [
                      _vm._v(
                        "                      \n                    " +
                          _vm._s(_vm.labels.stepOneWhatOurCustomersSayHeading) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-26" }, [
                      _vm._v(
                        _vm._s(_vm.labels.stepOneWhatOurCustomersSayContent) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }